import { Box, Button, ButtonGroup, ListItemIcon, MenuItem } from "@mui/material";
import { HeaderStyle } from "./TableCommonModule";
import { fontAwesomeIcons } from './TableCustomeIcon';
import {
  MaterialReactTable,
  useMaterialReactTable,
  MRT_ToggleDensePaddingButton,
  MRT_ToggleFullScreenButton,
  // MRT_GlobalFilterTextField,
  MRT_ShowHideColumnsButton,
} from 'material-react-table';
import { Padding } from "@mui/icons-material";
import deleteOrder from "./deleteOrder";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import { TbFileDownload } from "react-icons/tb";
import Loader from "../../../Comman/Loader/Loader";


export const commonTableOptions = ({
  filterButtonColor,CSVData,
  // isError,
  CSVLoader,
  handleClickCSVDownload,
  showMenu,
  OrdermanagementList,
  handleShow,
  handleFilterColor, Type,
  isRefetching,
  // columnFilters,
  handleShowMenu,
  globalFilter,
  sorting,
  windowHeight,
  // setColumnFilters,
  setGlobalFilter,
  setPagination,
  setSorting,
  rowCount,
  isLoading,
  pagination,
  handleClickColum,
  handleFilterClick,
}) =>
({
  icons: fontAwesomeIcons,
  positionGlobalFilter: "left",
  muiTableHeadCellProps: {
    sx: HeaderStyle?.headerTitle
  },
  muiTableBodyCellProps: {
    sx: HeaderStyle?.headerCell
  },
  muiTableBodyRowProps: { hover: false },
  getRowId: (row) => row.phoneNumber,
  enableColumnFilters: false,
  onGlobalFilterChange: setGlobalFilter,
  onPaginationChange: setPagination,
  onSortingChange: setSorting,
  enableFilterMatchHighlighting: true,
  rowCount,
  state: {
    // columnFilters,
    globalFilter,
    isLoading,
    pagination,
    // showAlertBanner: isError,
    showProgressBars: isRefetching,
    sorting,
  },
  enableFacetedValues: true,
  enableRowActions: true,
  enableRowSelection: false,
  enableColumnFilters: false,
  positionToolbarAlertBanner: 'bottom',
  muiSearchTextFieldProps: {
    size: 'small',
    variant: 'outlined',
    sx: { marginLeft: "auto" },
  },
  enableSortingRemoval: false,
  enableColumnActions: false,

  initialState: {
    showColumnFilters: false,
    showGlobalFilter: true,
    columnPinning: {
      left: ['mrt-row-expand', 'mrt-row-select'],
      right: ['mrt-row-actions'],
    },
  },
  muiPaginationProps: {
    color: 'secondary',
    rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
    shape: 'rounded',
    variant: 'outlined',
  },
  paginationDisplayMode: 'pages',


  renderToolbarInternalActions: ({ table }) => (
    <>
     {/* {CSVLoader === true ?
     <div className='mx-5 my-3'>
        <Loader />
      </div>  :  (CSVData?.length > 0 &&
     <Button onClick={handleClickCSVDownload} className='mx-5 my-3 button_CSV_' variant="outlined" startIcon={<TbFileDownload />}>
        CSV
      </Button>) } */}
      <Box>
        <ButtonGroup className='mx-2 my-3' variant="outlined" aria-label="Disabled button group">
          <Button onClick={handleClickColum} style={{ background: handleFilterColor() }} className='button_group buttonDisplay' table={table}
            startIcon={<svg
              width={16}
              height={16}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 2.5C14 1.11929 12.8807 0 11.5 0H2.5C1.11929 0 0 1.11929 0 2.5V11.5C0 12.8807 1.11929 14 2.5 14H6.22104L6.43257 13.1539C6.4455 13.1022 6.4597 13.0509 6.47515 13H5V10H8.94217L10 8.94217V5H13V6.23096C13.3194 6.09407 13.6586 6.01783 14 6.00224V2.5ZM1 11.5V10H4V13H2.5L2.35554 12.9931C1.59489 12.9204 1 12.2797 1 11.5ZM9 5V9H5V5H9ZM9 4H5V1H9V4ZM10 1H11.5L11.6445 1.00687C12.4051 1.07955 13 1.7203 13 2.5V4H10V1ZM1 4V2.5L1.00687 2.35554C1.07955 1.59489 1.7203 1 2.5 1H4V4H1ZM4 5V9H1V5H4ZM12.8085 7.54691L7.97965 12.3758C7.6981 12.6573 7.49837 13.0101 7.4018 13.3964L7.02736 14.8941C6.86453 15.5455 7.45451 16.1354 8.10585 15.9726L9.60359 15.5982C9.98986 15.5016 10.3426 15.3019 10.6242 15.0203L15.4531 10.1914C16.1833 9.46117 16.1833 8.27717 15.4531 7.54691C14.7228 6.81664 13.5388 6.81664 12.8085 7.54691ZM11.6499 13.9956L13.9956 11.6499L11.6499 13.9956Z"
                fill="#344054"
              />
            </svg>
            } > Display</Button>
          <Button onClick={handleFilterClick} style={{ background: filterButtonColor !== null && "#e0e0e045" }} className='button_group buttonFilter'
            startIcon={<svg
              width={19}
              height={18}
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.62734 0.875H15.3723C15.9282 0.875 16.4032 0.875 16.7832 0.9225C17.1857 0.973333 17.5748 1.0875 17.8948 1.3875C18.2198 1.69333 18.349 2.07417 18.4057 2.47C18.4582 2.83417 18.4582 3.28667 18.4582 3.80333V4.45C18.4582 4.8575 18.4582 5.20833 18.4282 5.5025C18.3948 5.81917 18.324 6.115 18.1523 6.39917C17.9815 6.68167 17.7523 6.88667 17.4873 7.07C17.2382 7.24333 16.9207 7.4225 16.5457 7.63333L14.094 9.01333C13.5357 9.3275 13.3415 9.44083 13.2115 9.55333C12.914 9.81167 12.7432 10.0992 12.6632 10.4583C12.629 10.6125 12.6248 10.8058 12.6248 11.3942V13.6708C12.6248 14.4217 12.6248 15.0592 12.5473 15.55C12.4657 16.0708 12.2748 16.5708 11.7748 16.8833C11.2857 17.1892 10.7482 17.1608 10.2248 17.0367C9.72067 16.9175 9.09984 16.6742 8.35484 16.3833L8.28317 16.355C7.93317 16.2183 7.62817 16.0992 7.3865 15.9742C7.1265 15.84 6.88484 15.6733 6.70067 15.4133C6.51317 15.15 6.439 14.8683 6.40484 14.58C6.37484 14.3175 6.37484 14.0025 6.37484 13.6508V11.3942C6.37484 10.8058 6.3715 10.6125 6.3365 10.4583C6.26085 10.1035 6.06764 9.78465 5.78817 9.55333C5.65817 9.44083 5.46317 9.3275 4.90567 9.01333L2.454 7.63333C2.079 7.4225 1.7615 7.24333 1.51234 7.07C1.24734 6.88667 1.01817 6.68167 0.847337 6.39917C0.675671 6.115 0.604837 5.81833 0.572337 5.5025C0.541504 5.20917 0.541504 4.8575 0.541504 4.45V3.80333C0.541504 3.28667 0.541504 2.83417 0.594004 2.47C0.650671 2.07417 0.779837 1.69333 1.10484 1.3875C1.42484 1.0875 1.81317 0.973333 2.2165 0.9225C2.5965 0.875 3.0715 0.875 3.62734 0.875ZM2.37317 2.16333C2.09484 2.19833 2.0065 2.255 1.96067 2.29917C1.919 2.3375 1.86567 2.405 1.83067 2.6475C1.79317 2.9125 1.7915 3.27417 1.7915 3.84583V4.42083C1.7915 4.86583 1.7915 5.1525 1.81484 5.37417C1.8365 5.58 1.87317 5.67917 1.91817 5.75333C1.964 5.82917 2.04067 5.915 2.22484 6.04333C2.41984 6.17833 2.68567 6.32917 3.0915 6.5575L5.519 7.92417L5.58567 7.96167C6.05234 8.22417 6.369 8.4025 6.60734 8.60917C7.08935 9.0158 7.42336 9.57043 7.55734 10.1867C7.62484 10.4925 7.62484 10.8367 7.62484 11.32V13.6192C7.62484 14.0125 7.62567 14.2542 7.64734 14.4358C7.66567 14.6008 7.6965 14.6567 7.719 14.6892C7.744 14.7242 7.794 14.7783 7.95984 14.8642C8.1365 14.955 8.38067 15.0508 8.76567 15.2017C9.5665 15.515 10.1057 15.7242 10.5132 15.8208C10.9123 15.9158 11.044 15.8667 11.1115 15.8242C11.1682 15.7883 11.2557 15.7158 11.3132 15.355C11.3732 14.9742 11.3748 14.4358 11.3748 13.6183V11.32C11.3748 10.8367 11.3748 10.4925 11.4432 10.1867C11.5769 9.57054 11.9106 9.01593 12.3923 8.60917C12.6307 8.4025 12.9482 8.22333 13.4132 7.96167L13.4807 7.92417L15.9082 6.5575C16.314 6.32917 16.5798 6.17833 16.7748 6.04333C16.959 5.915 17.0357 5.82917 17.0815 5.75333C17.1265 5.67917 17.1632 5.58 17.184 5.37417C17.2073 5.1525 17.2082 4.86583 17.2082 4.42V3.845C17.2082 3.27417 17.2065 2.91167 17.169 2.6475C17.134 2.405 17.0798 2.3375 17.0398 2.29917C16.9932 2.25583 16.9048 2.19833 16.6265 2.16333C16.3348 2.12583 15.939 2.125 15.3332 2.125H3.6665C3.06067 2.125 2.66567 2.12583 2.37317 2.16333Z"
                fill="#344054"
              />
            </svg>
            }>Filter</Button>
        </ButtonGroup>
      </Box>
    </>
  ),

  muiSelectCheckboxProps: { style: { color: '#F25042' } },

  renderRowActionMenuItems: ({ closeMenu, row, showMenu }) => (showMenu &&
    [<MenuItem
      key={1}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: 'visible',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          borderRadius: 3,
          mt: 1.5,
          '& .MuiAvatar-root': {
            width: 35,
            height: 35,
            ml: -0.5,
            mr: 1,
          },
          '&::before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 85,
            width: 13,
            height: 13,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
          },
        },
      }}
      className='email_'
      onClick={() => {
        handleShow();
        closeMenu();
        // setOrderData(row?.original)
      }}
      sx={{ m: 0 }}
    >
      <ListItemIcon>
        <MailOutlinedIcon />
      </ListItemIcon>
      Send Email
    </MenuItem>,
    <MenuItem
      key={2}
      className='delete_'
      style={{ color: "#D92D20" }}
      onClick={() => {
        closeMenu();
        deleteOrder(row?.original?._id, OrdermanagementList, pagination)
      }}
      sx={{ m: 0 }}
    >
      <ListItemIcon>
        <DeleteOutlineOutlinedIcon style={{ color: "#D92D20" }} />
      </ListItemIcon>
      Delete Order
    </MenuItem>]),

  manualSorting: true,
  manualFiltering: true,
  manualPagination: true,
  enableStickyHeader: true,
  enableStickyFooter: true,
  muiTableContainerProps: { sx: { maxHeight: windowHeight - 175 } },

  displayColumnDefOptions: {
    'mrt-row-actions': {
      size: 60,
      muiTableHeadCellProps: {
        align: 'start',
      },
      muiTableBodyRowProps: {
        align: 'center',
      },
    },
    'mrt-row-select': {
      enableColumnActions: true,
      size: 10,
      muiTableHeadCellProps: {
        style: {
          padding: "8px 0px 0px 18px",
          color: '#F25042' // Set color here
        },
      },
      muiTableBodyCellProps: {
        align: 'center',
      },
    },

  },
  // muiSelectCheckboxProps: { color: 'secondary' }

  // enableColumnResizing: true,
  // columnResizeMode: 'onChange',
  // layoutMode: 'grid'
});

